module.exports = __webpack_public_path__ + "static/media/AB_C7_1.5ff30d06.jpg";